const enCommon = require("./en/common.json");
const deCommon = require("./de/common.json");
const frCommon = require("./fr/common.json");
const esCommon = require("./es/common.json");
const ptCommon = require("./pt/common.json");
const ruCommon = require("./ru/common.json");
const jaCommon = require("./ja/common.json");

const resources = {
    en: { common: enCommon },
    de: { common: deCommon },
    fr: { common: frCommon },
    es: { common: esCommon },
    pt: { common: ptCommon },
    ru: { common: ruCommon },
    ja: { common: jaCommon }
};

const supportedLocales = Object.keys(resources);
const namespaces = ["common"];
const defaultLocale = "en";

module.exports = {
    resources,
    supportedLocales,
    namespaces,
    defaultLocale
};
